import React from 'react'
import Banner from './Components/Banner'


function Home() {
  return (
    <>
      <Banner/>  


    </>
  )
}

export default Home